// extracted by mini-css-extract-plugin
export default {"serviceConfigDialog":"serviceConfigDialog-QXKzK","title":"title-cwTFu","configTab":"configTab-Bw1ra"};